<template>
    <div class="listmain ">
        <h1 class="firTitle">智能家居技能介绍</h1>
        <span>
<p>
	OrionOS为智能家居开发者提供标准的开发接口,开发者仅需完成授权信息配置以及控制协议开发即可实现语音交互技能。
</p>
<p>
	以下为智能家居技术链路流程介绍：
</p>
      <img src="../../../../static/images/smartHomeImg/process.png" alt="流程图">
</span>
        <span>
<p>
	<span class="ql-author-7802039 ql-size-9">步骤如下：</span>
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">1.用户授权</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">用户通过语音APP发送授权信息,OrionOS转发授权信息到开发者技能网关完成授权</span>
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">2.设备发现</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">用户授权成功后,OrionOS按照智能家居设备发现协议请求开发者技能网关,开发者按照智能家居响应协议进行解析并返回设备列表</span>
</p>
<p>
	<strong class="ql-author-7802039 ql-size-9">3.设备控制</strong>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">用户发送语音控制指令,OrionOS完成语义解析并按照智能家居设备控制协议完成封装后请求到开发者技能网关,开发者解析完成后,对设备发起控制响应,OrionOS将按照开发者的语音指令对设备进行控制。控制流程如上图所示。</span>
</p>
<p>
	<span class="ql-author-7802039 ql-size-9"> 智能家居技能发布流程参照 </span>智能家居技能发布流程
</p>
<p>
	<span class="ql-author-7802039 ql-size-9"> 智能家居授权流程参照 </span>智能家居授权流程介绍
</p>
<p>
	<span class="ql-author-7802039 ql-size-9">智能家居对接协议请参考&nbsp;</span>
	 <router-link to='/tutor/zn_xygs' class="gs">
         OrionOS智能家居接入协议
        </router-link>
</p>
</span>

    </div>
</template>

<script>
    export default {
        name: ""
    };
</script>


<style rel="stylesheet/scss" lang="scss" scoped>
    h1,
    h2,
    h3,
    h4,
    h5 {
        padding: 0;
        margin: 0px;
        font-weight: normal;
    }

    ul,
    li {
        list-style: none;
    }

    .listmain {
        font-size: 14px;
        line-height: 26px;
        .firTitle {
            font-size: 20px;
            color: #1e4d79;
            margin-bottom: 30px;
        }
        .sedTitle {
            font-size: 16px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #f3f3f3;
            margin-bottom: 15px;
            margin-top: 50px;
            &.fir {
                margin-top: 0px;
            }
        }
        .thirdTitle {
            margin-top: 50px;
            font-weight: bold;
            line-height: 30px;
            font-size: 16px;
        }
        .codeTitle {
            font-weight: bold;
            line-height: 26px;
        }
        pre {
            margin-top: 20px;
        }
        img {
            margin: 30px 0;
            width: 100%;
        }
        table,
        table tr th,
        table tr td {
            border: 1px solid #000;
            text-align: center;
        }
        table {
            line-height: 30px;
            width: 100%;
            border-collapse: collapse;
        }
    }

    .el-submenu .el-menu-item {
        min-width: 190px;
        background: #f5f5f5;
    }

    .el-submenu {
        min-width: 190px;
        background: #f5f5f5;
    }

    img {
        margin-top: 30px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/tutor/smartHome/Znjjjnjs.vue